import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eBusDiemDonTraActionTypeIds, IBusDiemDonTraActionTypes } from "../../action-types/bus/IBusDiemDonTraActionTypes";
import { IBusDiemDonTraPageStateModel } from "../../page-state-model/bus/IBusDiemDonTraPageState";

const initialState: IBusDiemDonTraPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	bus_diemdontras: [],
	bus_diemdontra_editing: undefined,
	bus_diemdontra_selected_ids: [],
	bus_loaidiemdons: [],
	is_show_detail_modal: false,
	is_show_delete_confirm: false,
	is_show_import_modal: false,
	import_status: ePageBaseStatus.is_not_initialization,
	import_validated_datas: []
}

export const busDiemDonTraReducer = (state: IBusDiemDonTraPageStateModel = initialState, action: IBusDiemDonTraActionTypes): IBusDiemDonTraPageStateModel => {
	switch (action.type) {
		case eBusDiemDonTraActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eBusDiemDonTraActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_diemdontras: action.payload
			}
		case eBusDiemDonTraActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_diemdontras: []
			}
		case eBusDiemDonTraActionTypeIds.LOAD_LOAIDIEMDON_START:
			return {
				...state
			}
		case eBusDiemDonTraActionTypeIds.LOAD_LOAIDIEMDON_SUCCESS:
			return {
				...state,
				bus_loaidiemdons: action.payload
			}
		case eBusDiemDonTraActionTypeIds.LOAD_LOAIDIEMDON_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				bus_loaidiemdons: []
			}
		case eBusDiemDonTraActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				bus_diemdontra_editing: action.payload
			}
		case eBusDiemDonTraActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				bus_diemdontra_editing: undefined
			}
		case eBusDiemDonTraActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				bus_diemdontra_selected_ids: action.payload
			}
		case eBusDiemDonTraActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true
			}
		case eBusDiemDonTraActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false
			}
		case eBusDiemDonTraActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eBusDiemDonTraActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success(action.payload ? "Cập nhật thành công" : "Thêm mới thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false,
				bus_diemdontra_editing: undefined
			}
		case eBusDiemDonTraActionTypeIds.SAVE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		case eBusDiemDonTraActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eBusDiemDonTraActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success("Xoá dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false,
				bus_diemdontra_editing: undefined,
				bus_diemdontra_selected_ids: []
			}
		case eBusDiemDonTraActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false
			}
		case eBusDiemDonTraActionTypeIds.SHOW_IMPORT_MODAL:
			return {
				...state,
				is_show_import_modal: true,
				import_status: ePageBaseStatus.is_not_initialization,
				import_validated_datas: []
			}
		case eBusDiemDonTraActionTypeIds.CLOSE_IMPORT_MODAL:
			return {
				...state,
				is_show_import_modal: false,
				import_status: ePageBaseStatus.is_not_initialization,
				import_validated_datas: []
			}
		case eBusDiemDonTraActionTypeIds.VALIDATE_IMPORT_START:
			return {
				...state,
				import_status: ePageBaseStatus.is_loading
			}
		case eBusDiemDonTraActionTypeIds.VALIDATE_IMPORT_SUCCESS:
			return {
				...state,
				import_status: ePageBaseStatus.is_completed,
				import_validated_datas: action.payload || []
			}
		case eBusDiemDonTraActionTypeIds.VALIDATE_IMPORT_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				import_status: ePageBaseStatus.is_completed,
				import_validated_datas: []
			}
		case eBusDiemDonTraActionTypeIds.IMPORT_START:
			return {
				...state,
				import_status: ePageBaseStatus.is_saving
			}
		case eBusDiemDonTraActionTypeIds.IMPORT_SUCCESS:
			NotifyHelper.Success("Import điểm đón trả thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				import_status: ePageBaseStatus.is_completed,
				is_show_import_modal: false,
				import_validated_datas: []
			}
		case eBusDiemDonTraActionTypeIds.IMPORT_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				import_status: ePageBaseStatus.is_completed
			}
		default:
			return state;
	}
}
